// 不再维护该组件,请转移至emop-item中使用,该组件不要删除
// 不再维护该组件,请转移至emop-item中使用,该组件不要删除
// 不再维护该组件,请转移至emop-item中使用,该组件不要删除
// 不再维护该组件,请转移至emop-item中使用,该组件不要删除
// 不再维护该组件,请转移至emop-item中使用,该组件不要删除
// 不再维护该组件,请转移至emop-item中使用,该组件不要删除
// 不再维护该组件,请转移至emop-item中使用,该组件不要删除
// 不再维护该组件,请转移至emop-item中使用,该组件不要删除
// 不再维护该组件,请转移至emop-item中使用,该组件不要删除
// 不再维护该组件,请转移至emop-item中使用,该组件不要删除


import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmopFormItemDataType } from '../../common/EmopFormItemDataType';
@Component({
  selector: 'emop-form-item',
  templateUrl: './emop-form-item.component.html',
  styleUrls: ['./emop-form-item.component.scss']
})
export class EmopFormItemComponent implements OnInit {
  tempData: EmopFormItemDataType;
  passwordVisible: boolean = false;
  @Input() data: EmopFormItemDataType;
  @Output() blur = new EventEmitter;  // 输入框失去焦点
  @Output() enter = new EventEmitter;  // 输入框按下回车键
  @Output() onChange = new EventEmitter;  // 输入框内容修改
  @Output() onOpen = new EventEmitter;  // 下拉框打开回调
  @Output() btnClick = new EventEmitter;  // type为button时的按钮回调函数
  constructor() { }

  ngOnChanges({ data }): void {
    if (data) {
      data = data.currentValue;
      if (!data || data.constructor !== Object) return console.error('传入的formItemData类型错误');
      // 默认为true的数据
      ['enable', 'visible'].forEach(attribute => {
        data[attribute] = data[attribute] === undefined ? true : data[attribute];
      });
      if (data.type === 'lov' && data.multiple && typeof data.value === 'string' && data.value.indexOf('[') === -1) {
        data.value = [data.value];
      }
      if (data.type === 'lov' && data.multiple && typeof data.value === 'string' && data.value.indexOf('[') !== -1) {
        data.value = JSON.parse(data.value.replace('[', '["').replace(',', '","').replace(']', '"]'));
      }
      if (data.type === 'bool' && !data.value) {
        data.value = false;
      }
    }
  }
  ngOnInit(): void {
  }
  // 监听输入事件
  onInput(value, key) {
    this.data.value = value;
    this.onChange.emit({
      key,
      value
    });
  }
  onBlur(value) {
    this.blur.emit(this.data.value);
  }
  keyup(e) {
    if (e.key === 'Enter') {
      this.enter.emit();
    }
  }
  onOpenFn(data, isOpen) {
    this.onOpen.emit({
      data,
      isOpen
    });
  }
  btnClickFn() {
    this.btnClick.emit(this.data.key);
  }
}
